import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, Users, Wrench, Star, HelpCircle, LogOut } from "lucide-react";
import { Brand } from "../../components/Layout";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";

const NAV = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Dashboard" },
  { to: "/admin/opdrachten", icon: ClipboardList, label: "Opdrachten" },
  { to: "/admin/partners", icon: Users, label: "Partners" },
  { to: "/admin/diensten", icon: Wrench, label: "Diensten & prijzen" },
  { to: "/admin/reviews", icon: Star, label: "Reviews" },
  { to: "/admin/faq", icon: HelpCircle, label: "FAQ" },
];

export function AdminLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex flex-col w-64 bg-[#0F172A] text-white fixed inset-y-0">
        <div className="h-16 flex items-center px-6 border-b border-white/10"><Brand light /></div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-brand-orange text-white" : "text-slate-300 hover:bg-white/10"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <Button variant="outline" size="sm" className="w-full bg-transparent border-white/25 text-white hover:bg-white/10 hover:text-white" onClick={() => { logout(); navigate("/"); }} data-testid="admin-logout">
            <LogOut size={16} className="mr-1" /> Uitloggen
          </Button>
        </div>
      </aside>
      <div className="flex-1 lg:ml-64 min-w-0">
        <div className="lg:hidden bg-[#0F172A] text-white px-4 h-14 flex items-center justify-between">
          <Brand light />
          <div className="flex gap-1 overflow-x-auto">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `p-2 rounded ${isActive ? "text-brand-orange" : "text-slate-300"}`}><n.icon size={18} /></NavLink>
            ))}
          </div>
        </div>
        <main className="p-4 sm:p-6 lg:p-8 max-w-7xl">{children}</main>
      </div>
    </div>
  );
}
